import { useEffect, useState } from "react";
import MenuApp from '../../../components/Menu';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import informationService from '../../../services/system';
import AuthService from "../../../services/security/auth.service";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import BusinessCenterOutlined from '@mui/icons-material/BusinessCenterOutlined';
import WorkOutline from '@mui/icons-material/WorkOutline';
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import LockOpen from '@mui/icons-material/LockOpen';
import LockOutline from '@mui/icons-material/Lock';
import WalletOutlined from '@mui/icons-material/WalletOutlined';
import LocalAtmOutlined from '@mui/icons-material/LocalAtmOutlined';
import Sensors from '@mui/icons-material/Sensors';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Doughnut from '../../../components/Doughnut';
import { Card, CardContent, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import constantsDesign from '../../../utils/constants';
import DateComponent from '../../../components/Date';
import TokenService from "../../../services/security/token.service";

const backgroundColor = [
    "#1E3A8A", // Azul oscuro
    "#065F46", // Verde oscuro
    "#0D9488", // Turquesa oscuro
    "#F97316", // Naranja vibrante
    "#2563EB", // Azul vibrante
    "#047857", // Verde esmeralda
    "#14B8A6", // Turquesa medio
    "#FB923C", // Naranja medio
    "#3B82F6", // Azul claro
    "#059669", // Verde medio
    "#2DD4BF", // Turquesa claro
    "#FCD34D", // Naranja ámbar
    "#60A5FA", // Azul suave
    "#34D399", // Verde claro
    "#5EEAD4", // Turquesa suave
    "#FEF3C7", // Naranja muy claro
    "#93C5FD", // Azul muy claro
    "#6EE7B7", // Verde menta
    "#99F6E4"  // Turquesa muy claro
]

const Position = () => {
    const user = TokenService.getUser();
    const [entityBalance, setEntityBalance] = useState([]);
    const [entityBalanceUSD, setEntityBalanceUSD] = useState([]);
    const [entityHolding, setEntityHolding] = useState([]);
    const [entityHoldingUSD, setEntityHoldingUSD] = useState([]);
    const [subtotalesCards, setSubtotalesCards] = useState([]);
    const [subtotalesCardsUSD, setSubtotalesCardsUSD] = useState([]);
    const [loadSubtotalesCards, setLoadSubtotalesCards] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});
    const [expandedItemsUSD, setExpandedItemsUSD] = useState({});
    const [totalSubTotal, setSubTotal] = useState(0);
    const [totalSubTotalUSD, setSubTotalUSD] = useState(0);
    const [portafolioDisponible, setPortafolioDisponible] = useState({});
    const [portafolioGarantia, setPortafolioGarantia] = useState({});
    const [portafolioTotal, setPortafolioTotal] = useState({});
    const [portafolioDisponibleUSD, setPortafolioDisponibleUSD] = useState({});
    const [portafolioGarantiaUSD, setPortafolioGarantiaUSD] = useState({});
    const [portafolioTotalUSD, setPortafolioTotalUSD] = useState({});
    const [tipoCambio, setTipoCambio] = useState('');
    const [tipoCambioCcl, setTipoCambioCcl] = useState('');
    const [homeTrade, setHomeTrade] = useState('ars');
    const [filterDate, setFilterDate] = useState(null);
    const [filterComitente, setFilterComitente] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [optionsComitentes, setOptionsComitentes] = useState([]);
    const [optionsComitentesOriginales, setOptionsComitentesOriginales] = useState([]);
    const [filterManager, setFilterManager] = useState(null);
    const [inputValueManager, setInputValueManager] = useState('');
    const [optionsManager, setOptionsManager] = useState([]);
    const [viewComitente, setViewComitente] = useState(false);
    const [viewManager, setViewManager] = useState(false);


    useEffect(() => {
        document.title = `Home - wBroker`;
        setLoadSubtotalesCards(false);
        //if ((!user.data.managerId && !user.data.tradeAccountId) || user.data.isManager === '1')
        searchSourceField();
        let dateNow = formatDate(new Date());
        setFilterDate(dateNow);
        loadInfo(dateNow, filterComitente, filterManager);

        if (user.data.managerId && user.data.tradeAccountId) {
            setViewComitente(true);
            setViewManager(false);
        } else {
            if (user.data.managerId && !user.data.tradeAccountId) {
                setViewComitente(true);
                setViewManager(true);
            } else {
                if (!user.data.managerId && !user.data.tradeAccountId) {
                    setViewComitente(true);
                    setViewManager(true);
                }
            }
        }
        // eslint-disable-next-line
    }, []);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const filterByTradeAccountIdManagerId = (tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];

        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        } else {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: null
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : user.data.tradeAccountId
            })
        } else {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : null
            })
        }

        if (user.data.managerId) {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : user.data.managerId
            })
        } else {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : null
            })
        }


        return whereFieldParam;
    }

    const filterByTradeAccountIdManagerIdFindSourceField = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
        return whereFieldParam;
    }

    const searchSourceField = () => {
        let whereFilters = filterByTradeAccountIdManagerIdFindSourceField();

        const arrayTables = [{
            table: `${user.data.instance}.tradeAccount`,
            doc: [],
            selectFilters: ['managerId'],
            whereFilters: whereFilters
        }, {
            table: `${user.data.instance}.manager`,
            doc: [],
            selectFilters: [],
            whereFilters: whereFilters
        }]

        informationService.findSourceField(arrayTables).then((response) => {

            let opcComitentes = [];
            let opcManager = [];
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].source === 'tradeAccount' && response.data[t].isInactive === '0') {
                    opcComitentes.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                        managerId: response.data[t].managerId
                    })
                }
                if (response.data[t].source === 'manager' && response.data[t].isInactive === '0') {
                    opcManager.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                    })
                }
            }

            let managerId = 0;
            if (user.data.isManager === '1') {
                setFilterManager({
                    id: user.data.managerId,
                    label: user.data.manager,
                    isInactive: 0,
                });
                managerId = user.data.managerId;
            }
            if (user.data.tradeAccountId && user.data.managerId) {
                setFilterComitente({
                    id: user.data.tradeAccountId,
                    label: user.data.tradeAccount,
                    isInactive: 0,
                })
            }
            if (managerId > 0) {
                let arrayOptCom = [];
                for (let g = 0; g < opcComitentes.length; g++) {
                    if (Number(opcComitentes[g].managerId) === Number(managerId)) {
                        arrayOptCom.push(opcComitentes[g]);
                    }
                }
                setOptionsComitentes(arrayOptCom);
            } else {
                setOptionsComitentes(opcComitentes);
            }
            setOptionsComitentesOriginales(opcComitentes);
            setOptionsManager(opcManager);

            setLoadSubtotalesCards(true);

        })
    }

    const loadInfo = (value, tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();
        let date = value.split('-');
        let dueDateFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let dueDate = formatDate(dueDateFlag);

        let where = filterByTradeAccountIdManagerId(tradeAccountId, managerId);
        informationService.storeProcedurePosition('positionBalanceAsOf', user.data.instance, dueDate, where).then((response) => {

            let responseBalanceView = [];
            let totalSubP = 0;
            let totalSubU = 0;
            let totalSubC = 0;

            let responseBalanceViewUSD = [];
            let totalSubPESOS = 0;
            let totalSubUSD = 0;
            let totalSubCCL = 0;

            for (let t = 0; t < response.data.length; t++) {
                if (t === 0) {
                    let fxRateUsdMepFlag = Number(response.data[t].fxRateUsdMep).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplitRate = fxRateUsdMepFlag.split(',');
                    if (valueSplitRate.length > 1) {
                        fxRateUsdMepFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')},${valueSplitRate[1].slice(0, 2)}`;
                    } else {
                        fxRateUsdMepFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')}`;
                    }
                    setTipoCambio(fxRateUsdMepFlag);

                    let fxRateUsdMepCclFlag = Number(response.data[t].fxRateUsdCcl).toFixed(2).toString().replace(/\./g, ',');
                    valueSplitRate = fxRateUsdMepCclFlag.split(',');
                    if (valueSplitRate.length > 1) {
                        fxRateUsdMepCclFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')},${valueSplitRate[1].slice(0, 2)}`;
                    } else {
                        fxRateUsdMepCclFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')}`;
                    }
                    setTipoCambioCcl(fxRateUsdMepCclFlag);

                    //fxRateUsdMep = response.data[t].fxRateUsdMep;
                    let currencyObject = {};
                    currencyObject.name = `PESOS`;
                    currencyObject.status = response.data[t].status;
                    currencyObject.data = [response.data[t]];
                    responseBalanceView.push(currencyObject);

                    currencyObject = {};
                    currencyObject.name = `USD MEP`;
                    currencyObject.status = response.data[t].status;
                    currencyObject.data = [response.data[t]];
                    responseBalanceView.push(currencyObject);

                    currencyObject = {};
                    currencyObject.name = `USD CABLE`;
                    currencyObject.status = response.data[t].status;
                    currencyObject.data = [response.data[t]];
                    responseBalanceView.push(currencyObject);
                    //********************/
                    let currencyObjectUSD = {};
                    currencyObjectUSD.name = `PESOS`;
                    currencyObjectUSD.status = response.data[t].status;
                    //response.data[t].amountPesos = Number(response.data[t].amount) / Number(fxRateUsdMep).toFixed(2)
                    currencyObjectUSD.data = [response.data[t]];
                    responseBalanceViewUSD.push(currencyObjectUSD);

                    currencyObjectUSD = {};
                    currencyObjectUSD.name = `USD MEP`;
                    currencyObjectUSD.status = response.data[t].status;
                    currencyObjectUSD.data = [response.data[t]];
                    responseBalanceViewUSD.push(currencyObjectUSD);

                    currencyObjectUSD = {};
                    currencyObjectUSD.name = `USD CABLE`;
                    currencyObjectUSD.status = response.data[t].status;
                    currencyObjectUSD.data = [response.data[t]];
                    responseBalanceViewUSD.push(currencyObjectUSD);
                    //********************/
                }
                else {
                    let existe = false;
                    for (let d = 0; d < responseBalanceView.length; d++) {
                        let flagStatus = `${response.data[t].status}`;
                        if (responseBalanceView[d].status === flagStatus) {
                            existe = true;
                            responseBalanceView[d].data.push(response.data[t]);
                        }
                    }
                    if (!existe) {
                        let currencyObject = {};
                        currencyObject.name = `PESOS`;
                        currencyObject.status = response.data[t].status;
                        currencyObject.data = [response.data[t]];
                        responseBalanceView.push(currencyObject);

                        currencyObject = {};
                        currencyObject.name = `USD MEP`;
                        currencyObject.status = response.data[t].status;
                        currencyObject.data = [response.data[t]];
                        responseBalanceView.push(currencyObject);

                        currencyObject = {};
                        currencyObject.name = `USD CABLE`;
                        currencyObject.status = response.data[t].status;
                        currencyObject.data = [response.data[t]];
                        responseBalanceView.push(currencyObject);

                        let fxRateUsdMepFlag = Number(response.data[t].fxRateUsdMep).toFixed(2).toString().replace(/\./g, ',');
                        let valueSplitRate = fxRateUsdMepFlag.split(',');
                        if (valueSplitRate.length > 1) {
                            fxRateUsdMepFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')},${valueSplitRate[1].slice(0, 2)}`;
                        } else {
                            fxRateUsdMepFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')}`;
                        }
                        setTipoCambio(fxRateUsdMepFlag);

                        let fxRateUsdMepCclFlag = Number(response.data[t].fxRateUsdCcl).toFixed(2).toString().replace(/\./g, ',');
                        valueSplitRate = fxRateUsdMepCclFlag.split(',');
                        if (valueSplitRate.length > 1) {
                            fxRateUsdMepCclFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')},${valueSplitRate[1].slice(0, 2)}`;
                        } else {
                            fxRateUsdMepCclFlag = `${Number(valueSplitRate[0]).toLocaleString('es-AR')}`;
                        }
                        setTipoCambioCcl(fxRateUsdMepCclFlag);
                    }
                    //********************/
                    let existeUSD = false;
                    for (let d = 0; d < responseBalanceViewUSD.length; d++) {
                        let flagStatus = `${response.data[t].status}`;
                        if (responseBalanceViewUSD[d].status === flagStatus) {
                            existeUSD = true;
                            responseBalanceViewUSD[d].data.push(response.data[t]);
                        }
                    }
                    if (!existeUSD) {
                        let currencyObjectUSD = {};
                        currencyObjectUSD.name = `PESOS`;
                        currencyObjectUSD.status = response.data[t].status;
                        //response.data[t].amountPesos = Number(response.data[t].amount) / Number(fxRateUsdMep).toFixed(2)
                        currencyObjectUSD.data = [response.data[t]];
                        responseBalanceViewUSD.push(currencyObjectUSD);

                        currencyObjectUSD = {};
                        currencyObjectUSD.name = `USD MEP`;
                        currencyObjectUSD.status = response.data[t].status;
                        currencyObjectUSD.data = [response.data[t]];
                        responseBalanceViewUSD.push(currencyObjectUSD);

                        currencyObjectUSD = {};
                        currencyObjectUSD.name = `USD CABLE`;
                        currencyObjectUSD.status = response.data[t].status;
                        currencyObjectUSD.data = [response.data[t]];
                        responseBalanceViewUSD.push(currencyObjectUSD);
                    }
                    //********************/
                }
                totalSubP = (Number(totalSubP) + Number(response.data[t].amountFx)).toFixed(2);
                totalSubU = (Number(totalSubU) + Number(response.data[t].amountFxMep)).toFixed(2);
                totalSubC = (Number(totalSubC) + Number(response.data[t].amountFxCcl)).toFixed(2);
                totalSubPESOS = (Number(totalSubPESOS) + Number(response.data[t].amountMepFx)).toFixed(2);
                totalSubUSD = (Number(totalSubUSD) + Number(response.data[t].amountMep)).toFixed(2);
                totalSubCCL = (Number(totalSubCCL) + Number(response.data[t].amountCcl)).toFixed(2);

            }

            let totalPesosFlag = Number(totalSubP) + Number(totalSubU) + Number(totalSubC);

            let totalPesosFlagFlag = Number(totalPesosFlag).toFixed(2).toString().replace(/\./g, ',');
            let valueSplit = totalPesosFlagFlag.split(',');
            if (valueSplit.length > 1) {
                totalPesosFlagFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            } else {
                totalPesosFlagFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
            }
            setSubTotal({ "text": totalPesosFlagFlag, "number": totalPesosFlag });
            //****************** */

            let totalUsdFlag = Number(totalSubPESOS) + Number(totalSubUSD) + Number(totalSubCCL);

            let totalSubUSDFlag = Number(totalUsdFlag).toFixed(2).toString().replace(/\./g, ',');
            valueSplit = totalSubUSDFlag.split(',');
            if (valueSplit.length > 1) {
                totalSubUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            } else {
                totalSubUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
            }
            setSubTotalUSD({ "text": totalSubUSDFlag, "number": totalUsdFlag });
            //****************** */

            for (let d = 0; d < responseBalanceView.length; d++) {
                let arrayFlag = [];
                if (responseBalanceView[d].data.length > 1) {
                    let amount = 0;
                    let fieldId = null;
                    for (let t = 0; t < responseBalanceView[d].data.length; t++) {
                        if (responseBalanceView[d].name === 'PESOS') {
                            fieldId = 'amountFx';
                            //amount += Number(responseBalanceViewUSD[d].data[t].amountPesos);
                            amount += Number(responseBalanceView[d].data[t].amountFx);
                        }
                        if (responseBalanceView[d].name === 'USD MEP') {
                            fieldId = 'amountFxMep';
                            amount += Number(responseBalanceView[d].data[t].amountFxMep);
                        }
                        if (responseBalanceView[d].name === 'USD CABLE') {
                            fieldId = 'amountFxMep';
                            amount += Number(responseBalanceView[d].data[t].amountFxMep);
                        }
                    }
                    arrayFlag.push({
                        status: 'Total',
                        [fieldId]: amount
                    })
                }
                arrayFlag = arrayFlag.concat(responseBalanceView[d].data);
                responseBalanceView[d].status = arrayFlag;
            }

            //********************** */
            for (let d = 0; d < responseBalanceViewUSD.length; d++) {
                let arrayFlag = [];
                if (responseBalanceViewUSD[d].data.length > 1) {
                    let amount = 0;
                    let fieldId = null;
                    for (let t = 0; t < responseBalanceViewUSD[d].data.length; t++) {
                        if (responseBalanceViewUSD[d].name === 'PESOS') {
                            fieldId = 'amountMepFx';
                            //amount += Number(responseBalanceViewUSD[d].data[t].amountPesos);
                            amount += Number(responseBalanceViewUSD[d].data[t].amountMepFx);
                        }
                        if (responseBalanceViewUSD[d].name === 'USD MEP') {
                            fieldId = 'amountMep';
                            amount += Number(responseBalanceViewUSD[d].data[t].amountMep);
                        }
                        if (responseBalanceViewUSD[d].name === 'USD CABLE') {
                            fieldId = 'amountCcl';
                            amount += Number(responseBalanceViewUSD[d].data[t].amountCcl);

                        }
                    }
                    arrayFlag.push({
                        status: 'Total',
                        [fieldId]: amount
                    })
                }
                arrayFlag = arrayFlag.concat(responseBalanceViewUSD[d].data);
                responseBalanceViewUSD[d].status = arrayFlag;
            }
            //********************** */
            let responseBalanceViewFlag = [];
            for (let h = 0; h < responseBalanceView.length; h++) {
                if (h === 0) {
                    responseBalanceViewFlag.push(responseBalanceView[h]);
                } else {
                    let existe = false;
                    for (let j = 0; j < responseBalanceViewFlag.length; j++) {
                        if (responseBalanceViewFlag[j].name === responseBalanceView[h].name) {
                            responseBalanceViewFlag[j].status.push(responseBalanceView[h].status[0]);
                            responseBalanceViewFlag[j].data.push(responseBalanceView[h].data[0]);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        responseBalanceViewFlag.push(responseBalanceView[h]);
                    }
                }
            }


            setEntityBalance(responseBalanceViewFlag);
            let responseBalanceViewUSDFlag = [];
            for (let h = 0; h < responseBalanceViewUSD.length; h++) {
                if (h === 0) {
                    responseBalanceViewUSDFlag.push(responseBalanceViewUSD[h]);
                } else {
                    let existe = false;
                    for (let j = 0; j < responseBalanceViewUSDFlag.length; j++) {
                        if (responseBalanceViewUSDFlag[j].name === responseBalanceViewUSD[h].name) {
                            responseBalanceViewUSDFlag[j].status.push(responseBalanceViewUSD[h].status[0]);
                            responseBalanceViewUSDFlag[j].data.push(responseBalanceViewUSD[h].data[0]);
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        responseBalanceViewUSDFlag.push(responseBalanceViewUSD[h]);
                    }
                }
            }

            setEntityBalanceUSD(responseBalanceViewUSDFlag);
            informationService.storeProcedurePosition('positionHoldingAsOf', user.data.instance, dueDate, where).then((response) => {
                let responseEntityHoldingView = [];
                let totalDisponible = 0;
                let totalGarantia = 0;
                let subtotales = [];
                /************** */
                let responseEntityHoldingViewUSD = [];
                let totalDisponibleUSD = 0;
                let totalGarantiaUSD = 0;
                let subtotalesUSD = [];
                /************** */
                for (let t = 0; t < response.data.length; t++) {
                    if (t === 0) {
                        let especieObject = {};
                        especieObject.itemId = `${response.data[t].itemId}`;
                        especieObject.item = `${response.data[t].item}`;
                        especieObject.symbol = `${response.data[t].symbol ? response.data[t].symbol : ''}`;
                        especieObject.isin = `${response.data[t].isin ? response.data[t].isin : ''}`;
                        especieObject.assetClass = `${response.data[t].assetClass}`;
                        especieObject.assetClassId = `${response.data[t].assetClassId}`;
                        especieObject.subtotal = `${response.data[t].subtotal}`;
                        especieObject.status = [response.data[t]]
                        responseEntityHoldingView.push(especieObject);
                        subtotales.push({ subtotal: response.data[t].subtotal, cantidad: response.data[t].qty, importe: response.data[t].amountFx });

                        /************** */
                        let especieObjectUSD = {};
                        especieObjectUSD.itemId = `${response.data[t].itemId}`;
                        especieObjectUSD.item = `${response.data[t].item}`;
                        especieObjectUSD.symbol = `${response.data[t].symbol ? response.data[t].symbol : ''}`;
                        especieObjectUSD.isin = `${response.data[t].isin ? response.data[t].isin : ''}`;
                        especieObjectUSD.assetClass = `${response.data[t].assetClass}`;
                        especieObjectUSD.assetClassId = `${response.data[t].assetClassId}`;
                        especieObjectUSD.subtotal = `${response.data[t].subtotal}`;
                        especieObjectUSD.status = [response.data[t]]
                        /************** */
                        responseEntityHoldingViewUSD.push(especieObjectUSD);
                        subtotalesUSD.push({ subtotal: response.data[t].subtotal, cantidad: response.data[t].qty, importe: response.data[t].amountMep });
                    }
                    else {
                        let existe = false;
                        for (let d = 0; d < responseEntityHoldingView.length; d++) {
                            let flagItemId = `${response.data[t].itemId}`;
                            if (responseEntityHoldingView[d].itemId === flagItemId) {
                                existe = true;
                                responseEntityHoldingView[d].status.push(response.data[t]);
                            }
                        }
                        if (!existe) {
                            let especieObject = {};
                            especieObject.itemId = `${response.data[t].itemId}`;
                            especieObject.item = `${response.data[t].item}`;
                            especieObject.symbol = `${response.data[t].symbol ? response.data[t].symbol : ''}`;
                            especieObject.isin = `${response.data[t].isin ? response.data[t].isin : ''}`;
                            especieObject.assetClass = `${response.data[t].assetClass}`;
                            especieObject.assetClassId = `${response.data[t].assetClassId}`;
                            especieObject.subtotal = `${response.data[t].subtotal}`;
                            especieObject.status = [response.data[t]];
                            responseEntityHoldingView.push(especieObject);
                        }
                        let existeSubtotales = false;
                        for (let a = 0; a < subtotales.length; a++) {
                            if (subtotales[a].subtotal === response.data[t].subtotal) {
                                existeSubtotales = true;
                                subtotales[a].cantidad = Number(subtotales[a].cantidad) + Number(response.data[t].qty);
                                subtotales[a].importe = Number(subtotales[a].importe) + Number(response.data[t].amountFx);
                            }
                        }
                        if (existeSubtotales === false)
                            subtotales.push({ subtotal: response.data[t].subtotal, cantidad: response.data[t].qty, importe: response.data[t].amountFx });

                        /********************** */
                        let existeUSD = false;
                        for (let d = 0; d < responseEntityHoldingViewUSD.length; d++) {
                            let flagItemId = `${response.data[t].itemId}`;
                            if (responseEntityHoldingViewUSD[d].itemId === flagItemId) {
                                existeUSD = true;
                                responseEntityHoldingViewUSD[d].status.push(response.data[t]);
                            }
                        }
                        if (!existeUSD) {
                            let especieObjectUSD = {};
                            especieObjectUSD.itemId = `${response.data[t].itemId}`;
                            especieObjectUSD.item = `${response.data[t].item}`;
                            especieObjectUSD.symbol = `${response.data[t].symbol ? response.data[t].symbol : ''}`;
                            especieObjectUSD.isin = `${response.data[t].isin ? response.data[t].isin : ''}`;
                            especieObjectUSD.assetClass = `${response.data[t].assetClass}`;
                            especieObjectUSD.assetClassId = `${response.data[t].assetClassId}`;
                            especieObjectUSD.subtotal = `${response.data[t].subtotal}`;
                            especieObjectUSD.status = [response.data[t]];
                            responseEntityHoldingViewUSD.push(especieObjectUSD);
                        }

                        let existeSubtotalesUSD = false;
                        for (let a = 0; a < subtotalesUSD.length; a++) {
                            if (subtotalesUSD[a].subtotal === response.data[t].subtotal) {
                                existeSubtotalesUSD = true;
                                subtotalesUSD[a].cantidad = Number(subtotalesUSD[a].cantidad) + Number(response.data[t].qty);
                                subtotalesUSD[a].importe = Number(subtotalesUSD[a].importe) + Number(response.data[t].amountMep);
                            }
                        }
                        if (existeSubtotalesUSD === false)
                            subtotalesUSD.push({ subtotal: response.data[t].subtotal, cantidad: response.data[t].qty, importe: response.data[t].amountMep });

                        /********************** */
                    }

                    if (response.data[t].status === 'Disponible') {
                        totalDisponible = (Number(totalDisponible) + Number(response.data[t].amountFx)).toFixed(2);
                        totalDisponibleUSD = (Number(totalDisponibleUSD) + Number(response.data[t].amountMep)).toFixed(2);
                    }
                    if (response.data[t].status === 'Garantía') {
                        totalGarantia = (Number(totalGarantia) + Number(response.data[t].amountFx)).toFixed(2);
                        totalGarantiaUSD = (Number(totalGarantiaUSD) + Number(response.data[t].amountMep)).toFixed(2);
                    }
                }

                for (let a = 0; a < subtotales.length; a++) {
                    let cantidadFlag = Number(subtotales[a].cantidad).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = cantidadFlag.split(',');
                    if (valueSplit.length > 1) {
                        cantidadFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        cantidadFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }
                    subtotales[a].cantidadFinal = cantidadFlag;

                    let importeFlag = Number(subtotales[a].importe).toFixed(2).toString().replace(/\./g, ',');
                    valueSplit = importeFlag.split(',');
                    if (valueSplit.length > 1) {
                        importeFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        importeFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }
                    subtotales[a].importeFinal = importeFlag;
                }

                /********************* */
                for (let a = 0; a < subtotalesUSD.length; a++) {
                    let cantidadFlag = Number(subtotalesUSD[a].cantidad).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = cantidadFlag.split(',');
                    if (valueSplit.length > 1) {
                        cantidadFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        cantidadFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }
                    subtotalesUSD[a].cantidadFinal = cantidadFlag;

                    let importeFlag = Number(subtotalesUSD[a].importe).toFixed(2).toString().replace(/\./g, ',');
                    valueSplit = importeFlag.split(',');
                    if (valueSplit.length > 1) {
                        importeFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        importeFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }
                    subtotalesUSD[a].importeFinal = importeFlag;
                }
                /********************* */
                setSubtotalesCards(subtotales);
                /********** */
                setSubtotalesCardsUSD(subtotalesUSD);
                /********** */
                setLoadSubtotalesCards(true);
                let cuentaCorriente = 0;
                for (let d1 = 0; d1 < responseBalanceViewFlag.length; d1++) {
                    for (let d2 = 0; d2 < responseBalanceViewFlag[d1].data.length; d2++) {
                        let idField = 'amountFx'
                        if (responseBalanceViewFlag[d1].name === 'USD MEP')
                            idField = 'amountFxMep'
                        if (responseBalanceViewFlag[d1].name === 'USD CABLE')
                            idField = 'amountFxCcl'
                        cuentaCorriente += Number(responseBalanceViewFlag[d1].data[d2][idField]);
                    }
                }
                let totalPortafolio = Number(totalDisponible) + Number(totalGarantia) + Number(cuentaCorriente)

                totalPortafolio = totalPortafolio.toFixed(2);
                let totalDisponibleFlag = Number(totalDisponible).toFixed(2).toString().replace(/\./g, ',');
                let valueSplit = totalDisponibleFlag.split(',');
                if (valueSplit.length > 1) {
                    totalDisponibleFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalDisponibleFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                let totalGarantiaFlag = Number(totalGarantia).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = totalGarantiaFlag.split(',');
                if (valueSplit.length > 1) {
                    totalGarantiaFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalGarantiaFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                let totalPortafolioFlag = Number(totalPortafolio).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = totalPortafolioFlag.split(',');
                if (valueSplit.length > 1) {
                    totalPortafolioFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalPortafolioFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                setPortafolioDisponible({ 'number': totalDisponible, 'text': totalDisponibleFlag });
                setPortafolioGarantia({ 'number': totalGarantia, 'text': totalGarantiaFlag });
                setPortafolioTotal({ 'number': totalPortafolio, 'text': totalPortafolioFlag });

                /****************************** */
                let cuentaCorrienteUSD = 0;
                for (let d1 = 0; d1 < responseBalanceViewUSDFlag.length; d1++) {
                    for (let d2 = 0; d2 < responseBalanceViewUSDFlag[d1].data.length; d2++) {
                        let idField = 'amountMepFx'
                        if (responseBalanceViewUSDFlag[d1].name === 'USD MEP')
                            idField = 'amountMep'
                        if (responseBalanceViewUSDFlag[d1].name === 'USD CABLE')
                            idField = 'amountCcl'
                        cuentaCorrienteUSD += Number(responseBalanceViewUSDFlag[d1].data[d2][idField]);
                    }
                }

                let totalPortafolioUSD = Number(totalDisponibleUSD) + Number(totalGarantiaUSD) + Number(cuentaCorrienteUSD);

                totalPortafolioUSD = totalPortafolioUSD.toFixed(2);
                let totalDisponibleUSDFlag = Number(totalDisponibleUSD).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = totalDisponibleUSDFlag.split(',');
                if (valueSplit.length > 1) {
                    totalDisponibleUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalDisponibleUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                let totalGarantiaUSDlag = Number(totalGarantiaUSD).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = totalGarantiaUSDlag.split(',');
                if (valueSplit.length > 1) {
                    totalGarantiaUSDlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalGarantiaUSDlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                let totalPortafolioUSDFlag = Number(totalPortafolioUSD).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = totalPortafolioUSDFlag.split(',');
                if (valueSplit.length > 1) {
                    totalPortafolioUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    totalPortafolioUSDFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }

                setPortafolioDisponibleUSD({ 'number': totalDisponibleUSD, 'text': totalDisponibleUSDFlag });
                setPortafolioGarantiaUSD({ 'number': totalGarantiaUSD, 'text': totalGarantiaUSDlag });
                setPortafolioTotalUSD({ 'number': totalPortafolioUSD, 'text': totalPortafolioUSDFlag });
                /****************************** */

                for (let d = 0; d < responseEntityHoldingView.length; d++) {
                    let arrayFlag = [];
                    if (responseEntityHoldingView[d].status.length > 1) {
                        let amountTotal = 0;
                        let qtyTotal = 0;
                        let fxPrice = 0;
                        let costFx = 0;
                        let profitFx = 0;
                        for (let t = 0; t < responseEntityHoldingView[d].status.length; t++) {
                            amountTotal += Number(responseEntityHoldingView[d].status[t].amountFx);
                            fxPrice += Number(responseEntityHoldingView[d].status[t].fxPrice);
                            qtyTotal += Number(responseEntityHoldingView[d].status[t].qty);
                            costFx += Number(responseEntityHoldingView[d].status[t].costFx);
                            profitFx += Number(responseEntityHoldingView[d].status[t].profitFx);
                        }
                        arrayFlag.push({
                            status: 'Total',
                            amountFx: amountTotal,
                            qty: qtyTotal,
                            fxPrice: (Number(fxPrice) / responseEntityHoldingView[d].status.length).toFixed(2),
                            costFx,
                            profitFx
                        })
                    }
                    arrayFlag = arrayFlag.concat(responseEntityHoldingView[d].status);
                    responseEntityHoldingView[d].status = arrayFlag;
                }


                /************** */
                for (let d = 0; d < responseEntityHoldingViewUSD.length; d++) {
                    let arrayFlag = [];
                    if (responseEntityHoldingViewUSD[d].status.length > 1) {
                        let amountTotal = 0;
                        let qtyTotal = 0;
                        let fxPriceMep = 0;
                        let costMep = 0;
                        let profitMep = 0;
                        for (let t = 0; t < responseEntityHoldingViewUSD[d].status.length; t++) {
                            amountTotal += Number(responseEntityHoldingViewUSD[d].status[t].amountMep);
                            fxPriceMep += Number(responseEntityHoldingViewUSD[d].status[t].fxPriceMep);
                            qtyTotal += Number(responseEntityHoldingViewUSD[d].status[t].qty);
                            costMep += Number(responseEntityHoldingViewUSD[d].status[t].costMep);
                            profitMep += Number(responseEntityHoldingViewUSD[d].status[t].profitMep);
                        }
                        arrayFlag.push({
                            status: 'Total',
                            amountMep: amountTotal,
                            qty: qtyTotal,
                            fxPriceMep: (Number(fxPriceMep) / responseEntityHoldingViewUSD[d].status.length).toFixed(2),
                            costMep,
                            profitMep
                        })
                    }
                    arrayFlag = arrayFlag.concat(responseEntityHoldingViewUSD[d].status);
                    responseEntityHoldingViewUSD[d].status = arrayFlag;
                }
                /************* */
                setEntityHolding(responseEntityHoldingView);
                const expandedInitialState = {};
                responseEntityHoldingView.forEach(item => {
                    expandedInitialState[item.itemId] = true;
                });
                setExpandedItems(expandedInitialState);

                /************ */
                setEntityHoldingUSD(responseEntityHoldingViewUSD);
                const expandedInitialStateUSD = {};
                responseEntityHoldingViewUSD.forEach(item => {
                    expandedInitialStateUSD[item.itemId] = true;
                });
                setExpandedItemsUSD(expandedInitialStateUSD);
                /************ */
            });

        }).catch((error) => {
            console.log(error);
        });
    }

    const handleFieldChange = (e) => {
        let value = e.target.value;
        setFilterDate(value);
        setLoadSubtotalesCards(false);

        loadInfo(value, filterComitente, filterManager);
    }

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);

        const filtered = optionsComitentes.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterComitente(filtered[0]);
            setLoadSubtotalesCards(false);

            loadInfo(filterDate, filtered[0], filterManager)
        }
    };

    const handleChange = (event, newValue) => {
        setFilterComitente(newValue);
        setLoadSubtotalesCards(false);

        loadInfo(filterDate, newValue, filterManager)
    };

    const handleInputChangeManager = (event, newInputValue) => {
        setInputValueManager(newInputValue);

        const filtered = optionsManager.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterManager(filtered[0]);
            setLoadSubtotalesCards(false);
            let arrayOptCom = [];
            for (let g = 0; g < optionsComitentesOriginales.length; g++) {
                if (optionsComitentesOriginales[g].managerId === filtered[0].id) {
                    arrayOptCom.push(optionsComitentesOriginales[g]);
                }
            }
            setOptionsComitentes(arrayOptCom);
            loadInfo(filterDate, filterComitente, filtered[0])
        }
    };

    const handleChangeManager = (event, newValue) => {
        setFilterManager(newValue);
        setLoadSubtotalesCards(false);
        let arrayOptCom = [];
        for (let g = 0; g < optionsComitentesOriginales.length; g++) {
            if (optionsComitentesOriginales[g].managerId === newValue.id) {
                arrayOptCom.push(optionsComitentesOriginales[g]);
            }
        }
        setOptionsComitentes(arrayOptCom);
        loadInfo(filterDate, filterComitente, newValue)
    };

    const setViewEntityBalance = (item) => {
        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let cantidad = 0;
            let fieldId = null;
            let fieldIdCantidad = null;
            if (item.name === 'PESOS') {
                amount = Number(item.data[g].amountFx).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFx';
                cantidad = Number(item.data[g].amount).toFixed(2).toString().replace(/\./g, ',');
                fieldIdCantidad = 'amount';
            }

            if (item.name === 'USD MEP') {
                amount = Number(item.data[g].amountFxMep).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFxMep';
                cantidad = Number(item.data[g].amountMep).toFixed(2).toString().replace(/\./g, ',');
                fieldIdCantidad = 'amountMep';
            }

            if (item.name === 'USD CABLE') {
                amount = Number(item.data[g].amountFxCcl).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFxCcl';
                cantidad = Number(item.data[g].amountCcl).toFixed(2).toString().replace(/\./g, ',');
                fieldIdCantidad = 'amountCcl';
            }

            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            valueSplit = cantidad.split(',');
            if (valueSplit.length > 1) {
                cantidad = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{item.data[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldIdCantidad]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                            <span>{cantidad}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{item.data[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldIdCantidad]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                            <span>{cantidad}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const setViewEntityBalanceUSD = (item) => {
        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let amountMepFx = 0;
            let fieldId = null;
            if (item.name === 'PESOS') {
                amount = Number(item.data[g].amount).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amount';
                amountMepFx = Number(item.data[g].amountMepFx).toFixed(2).toString().replace(/\./g, ',');
            }

            if (item.name === 'USD MEP') {
                amount = Number(item.data[g].amountMep).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountMep';
            }

            if (item.name === 'USD CABLE') {
                amount = Number(item.data[g].amountCcl).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountCcl';
            }

            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            if (item.name === 'PESOS') {
                valueSplit = amountMepFx.split(',');
                if (valueSplit.length > 1) {
                    amountMepFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                }
            }

            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell style={{ fontWeight: 'bold' }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{item.data[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                            <span>{amount}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                            <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                            <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                        </div></TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>{item.data[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                            <span>{amount}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                            <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                        </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.data[g][fieldId]) < 0 ? "red" : "black" }} align='right'><div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                            <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                        </div></TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const toggleItem = (itemId) => {
        setExpandedItems(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const toggleItemUSD = (itemId) => {
        setExpandedItemsUSD(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const amountCtaCte = (item) => {
        let amountFx = 0;
        let flagAmount = 0;
        if (item.name === 'PESOS') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFx);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD MEP') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFxMep);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD CABLE') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFxCcl);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        let valueSplit = amountFx.split(',');
        if (valueSplit.length > 1) {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return { "number": flagAmount, "text": amountFx }
    }

    const amountCtaCteUSD = (item) => {
        let amountFx = 0;
        let flagAmount = 0;
        if (item.name === 'PESOS') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountMepFx);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD MEP') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountMep);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD CABLE') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountCcl);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        let valueSplit = amountFx.split(',');
        if (valueSplit.length > 1) {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return { "number": flagAmount, "text": amountFx }
    }

    const setViewEntitHolding = (entityHolding) => {
        let response = [];
        let subtotalAmount = 0;
        let subtotalCostFx = 0;
        let resultadoTotal = 0;
        let subtotal = null;
        let rowIndex = 0;
        entityHolding.forEach((item, index) => {
            const isItemExpanded = expandedItems[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;

            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    const isFirstRow = g === 0;
                    let amountFx = Number(item.status[g].amountFx).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = amountFx.split(',');
                    if (valueSplit.length > 1) {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPrice = '0,00';
                    if (item.status[g].fxPrice) {
                        fxPrice = Number(item.status[g].fxPrice).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPrice.split(',');
                        if (valueSplit.length > 1) {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costFx = '0,00';
                    if (item.status[g].costFx) {
                        costFx = Number(item.status[g].costFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costFx.split(',');
                        if (valueSplit.length > 1) {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let profitFx = '0,00';
                    if (item.status[g].profitFx) {
                        profitFx = Number(item.status[g].profitFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitFx.split(',');
                        if (valueSplit.length > 1) {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell style={{ fontWeight: 'bold' }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black" }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(subtotalCostFx) < 0 ? "red" : "black" }} align='right'>{subtotalCostFxFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black" }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                        subtotalCostFx = Number(item.status[g].costFx ? item.status[g].costFx : 0);
                        resultadoTotal = Number(item.status[g].profitFx ? item.status[g].profitFx : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        if (validate === true && item.status[g].status === 'Total') {
                            subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                            subtotalCostFx = Number(subtotalCostFx) + Number(item.status[g].costFx ? item.status[g].costFx : 0);
                            resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitFx : 0);


                        } else {
                            if (validate === false && item.status[g].status !== 'Total') {
                                subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                                subtotalCostFx = Number(subtotalCostFx) + Number(item.status[g].costFx ? item.status[g].costFx : 0);
                                resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitFx : 0);
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItem(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell> {isFirstRow && (<>{item.symbol}</>)}</TableCell>
                        <TableCell>{isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell>{item.status[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black" }} align='right'>{qty}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].fxPrice) < 0 ? "red" : "black" }} align='right'>{fxPrice}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].amountFx) < 0 ? "red" : "black" }} align='right'>{amountFx}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black" }} align='right'>{costFx}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem" }} align='right'>{item.status.length === 1 ? item.status[g].lotMonthAge : (item.status.length > 1 && item.status[g].status === 'Total') ? item.status[1].lotMonthAge : ""}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem" }} align="right">
                            {item.status.length === 1 ? (
                                <>
                                    {(Number(item.status[g].profitPerc) * 100).toFixed(0)}%
                                    {Number(item.status[g].profitFx) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitFx) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : null}
                                </>
                            ) : item.status.length > 1 && item.status[g].status === "Total" ? (
                                <>
                                    {(Number(item.status[1].profitPerc) * 100).toFixed(0)}%
                                    {Number(item.status[g].profitFx) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitFx) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : null}
                                </>
                            ) : null}
                        </TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].profitFx) < 0 ? "red" : "black" }} align='right'>{profitFx}</TableCell>
                    </TableRow>

                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    if (index === entityHolding.length - 1) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell style={{ fontWeight: 'bold' }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black" }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black" }} align='right'>{subtotalCostFxFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black" }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })

        return response;
    };

    const setViewEntitHoldingMEP = (entityHoldingUSD) => {

        let response = [];
        let subtotalAmount = 0;
        let subtotal = null;
        let resultadoTotal = 0;
        let subtotalCostMep = 0;
        let rowIndex = 0;
        entityHoldingUSD.forEach((item, index) => {
            const isItemExpanded = expandedItemsUSD[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;

            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    const isFirstRow = g === 0;
                    let amountMep = Number(item.status[g].amountMep).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = amountMep.split(',');
                    if (valueSplit.length > 1) {
                        amountMep = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountMep = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPriceMep = '0,00';
                    if (item.status[g].fxPriceMep) {
                        fxPriceMep = Number(item.status[g].fxPriceMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPriceMep.split(',');
                        if (valueSplit.length > 1) {
                            fxPriceMep = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPriceMep = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty.toString()).toFixed(2).replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costMep = '0,00';
                    if (item.status[g].costMep) {
                        costMep = Number(item.status[g].costMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costMep.split(',');
                        if (valueSplit.length > 1) {
                            costMep = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costMep = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let profitMep = '0,00';
                    if (item.status[g].profitMep) {
                        profitMep = Number(item.status[g].profitMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitMep.split(',');
                        if (valueSplit.length > 1) {
                            profitMep = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitMep = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell style={{ fontWeight: 'bold' }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black" }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black" }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black" }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountMep ? item.status[g].amountMep : 0);
                        subtotalCostMep = Number(item.status[g].costMep ? item.status[g].costMep : 0);
                        resultadoTotal = Number(item.status[g].profitMep ? item.status[g].profitMep : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        if (validate === true && item.status[g].status === 'Total') {
                            subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountMep : 0);
                            subtotalCostMep = Number(subtotalCostMep) + Number(item.status[g].costFx ? item.status[g].costMep : 0);
                            resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitMep : 0);

                        } else {
                            if (validate === false && item.status[g].status !== 'Total') {
                                subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountMep : 0);
                                subtotalCostMep = Number(subtotalCostMep) + Number(item.status[g].costFx ? item.status[g].costMep : 0);
                                resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitMep : 0);
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItemUSD(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell> {isFirstRow && (<>{item.symbol}</>)}</TableCell>
                        <TableCell>{isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell>{item.status[g].status}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black" }} align='right'>{qty}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].fxPriceMep) < 0 ? "red" : "black" }} align='right'>{fxPriceMep}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].amountMep) < 0 ? "red" : "black" }} align='right'>{amountMep}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].costMep) < 0 ? "red" : "black" }} align='right'>{costMep}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem" }} align='right'>{item.status.length === 1 ? item.status[g].lotMonthAge : (item.status.length > 1 && item.status[g].status === 'Total') ? item.status[1].lotMonthAge : ""}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem" }} align="right">
                            {item.status.length === 1 ? (
                                <>
                                    {(Number(item.status[g].profitPerc) * 100).toFixed(0)}%
                                    {Number(item.status[g].profitMep) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitMep) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : null}
                                </>
                            ) : item.status.length > 1 && item.status[g].status === "Total" ? (
                                <>
                                    {(Number(item.status[1].profitPerc) * 100).toFixed(0)}%
                                    {Number(item.status[g].profitMep) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitMep) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : null}
                                </>
                            ) : null}
                        </TableCell>

                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].profitMep) < 0 ? "red" : "black" }} align='right'>{profitMep}</TableCell>
                    </TableRow>
                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    if (index === entityHoldingUSD.length - 1) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell style={{ fontWeight: 'bold' }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black" }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black" }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{ letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black" }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })

        return response;
    };

    const totalImporteFinal = subtotalesCards.reduce(
        (sum, card) => sum + Number(card.importe), 0
    );

    const totalImporteFinalUSD = subtotalesCardsUSD.reduce(
        (sum, card) => sum + Number(card.importe), 0
    );

    const handleChangeHomeTrade = (homeTrade) => {
        setHomeTrade(homeTrade);
    }

    const getRowStyle = (isSubtotal, rowIndex) => {
        let baseColor = "white";

        if (isSubtotal) {
            baseColor = "rgba(0, 0, 0, 0.04)";
        } else {
            baseColor = rowIndex % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.02)";
        }

        return {
            backgroundColor: baseColor,
            "&:hover": {
                backgroundColor: "#e6ffff", // color al pasar con el mouse
            },
        };
    };

    return (
        <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
            <div style={{ overflowX: 'hidden' }}>
                <MenuApp />
                <Box border={1} marginTop="4rem" borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                    <Box display="flex" alignItems="center" gap={1}>


                        <ThemeProvider theme={constantsDesign.CUSTOM_MUI_BUTTON_THEME}>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" }, // columna en mobile, fila en grande
                                    gap: 1
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 1
                                    }}
                                >
                                    <BusinessCenterOutlined fontSize="large" />

                                    <Button
                                        color="primary"
                                        variant={homeTrade === 'ars' ? 'contained' : 'outlined'}
                                        sx={{ height: 32, minWidth: 50 }}
                                        onClick={() => handleChangeHomeTrade('ars')}
                                    >
                                        ARS
                                    </Button>

                                    <Button
                                        color="primary"
                                        variant={homeTrade !== 'ars' ? 'contained' : 'outlined'}
                                        sx={{ height: 32, minWidth: 50 }}
                                        onClick={() => handleChangeHomeTrade('usd')}
                                    >
                                        USD
                                    </Button>

                                    <DateComponent
                                        disabled={false}
                                        id="filterDate"
                                        name="Liquidación"
                                        value={filterDate}
                                        onChange={(newDate) => handleFieldChange({ target: { value: newDate } })}
                                        help={null}
                                        mode="c"
                                        design={null}
                                        view={null}
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" }, // apila en mobile, fila en grande
                                        gap: 1,
                                        flex: 1
                                    }}
                                >
                                    {viewComitente && (
                                        <>
                                            <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                                {loadSubtotalesCards && (
                                                    <Autocomplete
                                                        options={optionsComitentes}
                                                        getOptionLabel={(option) => option.label}
                                                        value={filterComitente}
                                                        onChange={handleChange}
                                                        inputValue={inputValue}
                                                        onInputChange={handleInputChange}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        disabled={(user.data.managerId && user.data.tradeAccountId) ? true : false}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Cuenta Comitente"
                                                                variant="outlined"
                                                                sx={{
                                                                    '& .MuiInputBase-root': {
                                                                        height: 32,
                                                                        minHeight: 32,
                                                                        paddingRight: '8px',
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        lineHeight: "inherit"
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '0 8px',
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        lineHeight: "inherit"
                                                                    },
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        top: '-4px',
                                                                    },

                                                                    '& .MuiInputLabel-shrink': {
                                                                        transform: 'translate(14px, -3px) scale(0.58)',
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline legend': {
                                                                        maxWidth: 0,
                                                                    },
                                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                        maxWidth: 2500,
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        fullWidth
                                                        slotProps={{
                                                            popper: {
                                                                sx: {
                                                                    '& .MuiAutocomplete-option': {
                                                                        fontSize: 'inherit'
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    )}
                                    {viewManager && (
                                        <>
                                            <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                                {loadSubtotalesCards && (
                                                    <Autocomplete
                                                        options={optionsManager}
                                                        getOptionLabel={(option) => option.label}
                                                        value={filterManager}
                                                        onChange={handleChangeManager}
                                                        inputValue={inputValueManager}
                                                        onInputChange={handleInputChangeManager}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        disabled={(user.data.managerId && !user.data.tradeAccountId) ? true : false}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Agente Productor"
                                                                variant="outlined"
                                                                sx={{
                                                                    '& .MuiInputBase-root': {
                                                                        height: 32,
                                                                        minHeight: 32,
                                                                        paddingRight: '8px',
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        lineHeight: "inherit"
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '0 8px',
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        lineHeight: "inherit"
                                                                    },
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: "inherit",
                                                                        fontWeight: '600',
                                                                        top: '-4px',
                                                                    },
                                                                    '& .MuiInputLabel-shrink': {
                                                                        transform: 'translate(14px, -3px) scale(0.58)',
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline legend': {
                                                                        maxWidth: 0,
                                                                    },
                                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                        maxWidth: 2500,
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        fullWidth
                                                    />
                                                )}
                                            </Box>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </ThemeProvider>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' }, // responsive: en mobile apila
                            justifyContent: 'space-between',             // separa gráfico y tabla
                            alignItems: 'flex-start',                    // alinea arriba
                            gap: 4,                                       // espacio entre ambos
                            width: '100%',
                            marginTop: '20px'
                        }}
                    >

                        <Box
                            sx={{
                                width: { xs: '100%', md: 600 },
                                mt: { xs: 4, md: 0 },
                                ml: { xs: 0, md: 'auto' },
                            }}
                        >
                            {loadSubtotalesCards && (
                                <TableContainer component={Paper} sx={{ maxHeight: 400, overflowX: 'auto', overflowY: 'auto', flex: 1, width: '100%' }}>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow sx={getRowStyle(false, 0)}>
                                                <TableCell> <Box display="flex" alignItems="center" gap={1}>
                                                    <WorkOutline />
                                                    Portafolio
                                                </Box></TableCell>
                                                <TableCell></TableCell>
                                                {homeTrade === 'ars' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioTotal.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>$</span>
                                                            <span>{portafolioTotal.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                                {homeTrade === 'usd' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioTotalUSD.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>USD</span>
                                                            <span>{portafolioTotalUSD.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                            </TableRow>

                                            <TableRow sx={getRowStyle(false, 1)}>
                                                <TableCell><Box display="flex" alignItems="center" gap={1}><LockOpen />Disponible </Box></TableCell>
                                                <TableCell></TableCell>
                                                {homeTrade === 'ars' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioDisponible.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>$</span>
                                                            <span>{portafolioDisponible.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                                {homeTrade === 'usd' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioDisponibleUSD.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>USD</span>
                                                            <span>{portafolioDisponibleUSD.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                            <TableRow sx={getRowStyle(false, 2)}>
                                                <TableCell><Box display="flex" alignItems="center" gap={1}><LockOutline />Garantía</Box></TableCell>
                                                <TableCell></TableCell>
                                                {homeTrade === 'ars' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioGarantia.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>$</span>
                                                            <span>{portafolioGarantia.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                                {homeTrade === 'usd' && (
                                                    <TableCell style={{ letterSpacing: "0.01rem", color: Number(portafolioGarantiaUSD.number) < 0 ? "red" : "black" }} align="right">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                            <span>USD</span>
                                                            <span>{portafolioGarantiaUSD.text}</span>
                                                        </div>
                                                    </TableCell>
                                                )}
                                            </TableRow>

                                            {homeTrade === 'ars' && (
                                                entityBalance.map((item, idx) => {
                                                    return <TableRow sx={getRowStyle(false, idx + 1)}>
                                                        <TableCell><Box display="flex" alignItems="center" gap={1}>{item.name === 'PESOS' ? <WalletOutlined /> : item.name === 'USD MEP' ? <LocalAtmOutlined /> : <Sensors />}{item.name}</Box></TableCell>
                                                        <TableCell>{item.name === 'USD MEP' ? `TC:${tipoCambio}` : item.name === 'USD CABLE' ? `TC:${tipoCambioCcl}` : ''}</TableCell>
                                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(amountCtaCte(item).number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>$</span>
                                                                <span>{amountCtaCte(item).text}</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                })
                                            )}
                                            {homeTrade === 'usd' && (
                                                entityBalanceUSD.map((item, idx) => {
                                                    return <TableRow sx={getRowStyle(false, idx + 1)}>
                                                        <TableCell><Box display="flex" alignItems="center" gap={1}>{item.name === 'PESOS' ? <WalletOutlined /> : item.name === 'USD MEP' ? <LocalAtmOutlined /> : <Sensors />}{item.name}</Box></TableCell>
                                                        <TableCell>{item.name === 'USD MEP' ? `TC:${tipoCambio}` : item.name === 'USD CABLE' ? `TC:${tipoCambioCcl}` : ''}</TableCell>
                                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(amountCtaCteUSD(item).number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>USD</span>
                                                                <span>{amountCtaCteUSD(item).text}</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                            {!loadSubtotalesCards && (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <CircularProgress size={60} />
                                </div>
                            )}
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' }, // Responsive
                                gap: 2,
                                flex: 1,
                            }}
                        >

                            {homeTrade === 'ars' && subtotalesCards.length > 0 && (
                                <Box sx={{ width: 250, height: 250, mx: 'auto' }}>
                                    {loadSubtotalesCards && subtotalesCards.length > 0 && (
                                        <Doughnut subtotalesCards={subtotalesCards} tot={portafolioTotal.text} />
                                    )}
                                    {!loadSubtotalesCards && (
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <CircularProgress size={60} />
                                        </div>
                                    )}
                                </Box>
                            )}

                            {homeTrade === 'usd' && subtotalesCardsUSD.length > 0 && (
                                <Box sx={{ width: 250, height: 250, mx: 'auto' }}>
                                    {loadSubtotalesCards && subtotalesCardsUSD.length > 0 && (
                                        <Doughnut subtotalesCards={subtotalesCardsUSD} tot={portafolioTotalUSD.text} />
                                    )}
                                    {!loadSubtotalesCards && (
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <CircularProgress size={60} />
                                        </div>
                                    )}
                                </Box>
                            )}
                            <Grid
                                container
                                spacing={2}
                                sx={{
                                    flex: 1,
                                    alignContent: 'flex-start',
                                }}
                            >
                                {homeTrade === 'ars' && (

                                    subtotalesCards.map((card, index) => (
                                        <Grid
                                            item
                                            key={index}
                                            xs={12}   // 1 por fila en mobile
                                            sm={6}    // 2 por fila en tablet
                                            lg={4}    // 4 por fila en desktop
                                        >
                                            <Card
                                                sx={{
                                                    borderTop: '6px solid ' + backgroundColor[index], // línea superior con color azul
                                                    borderRadius: 2,
                                                    boxShadow: 2,
                                                }}
                                            >
                                                <CardContent>
                                                    <Typography color={"black"} variant="body3" gutterBottom>
                                                        {`${card.subtotal}`}
                                                    </Typography>
                                                    <Typography
                                                        variant="body3"
                                                        sx={{
                                                            whiteSpace: 'pre-line',
                                                            fontWeight: 'bold'
                                                        }}
                                                        color={Number(card.importe) < 0 ? "red" : "black"}
                                                    >
                                                        {`\n${card.importeFinal}`}
                                                    </Typography>
                                                    <Typography
                                                        variant="body3"
                                                        sx={{
                                                            whiteSpace: 'pre-line',
                                                        }}
                                                        color={Number(card.importe) < 0 ? "red" : "black"}
                                                    >
                                                        {`\n${((Number(card.importe) / totalImporteFinal) * 100).toFixed(2)}%`}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))

                                )}

                                {homeTrade === 'usd' && (

                                    subtotalesCardsUSD.map((card, index) => (
                                        <Grid
                                            item
                                            key={index}
                                            xs={12}   // 1 por fila en mobile
                                            sm={6}    // 2 por fila en tablet
                                            lg={4}    // 4 por fila en desktop
                                        >
                                            <Card
                                                sx={{
                                                    borderTop: '6px solid ' + backgroundColor[index], // línea superior con color azul
                                                    borderRadius: 2,
                                                    boxShadow: 2,
                                                }}
                                            >
                                                <CardContent>
                                                    <Typography color={"black"} variant="body3" gutterBottom>
                                                        {`${card.subtotal}`}
                                                    </Typography>
                                                    <Typography
                                                        variant="body3"
                                                        sx={{
                                                            whiteSpace: 'pre-line',
                                                            fontWeight: 'bold'
                                                        }}
                                                        color={Number(card.importe) < 0 ? "red" : "black"}
                                                    >
                                                        {`\n${card.importeFinal}`}
                                                    </Typography>
                                                    <Typography
                                                        variant="body3"
                                                        sx={{
                                                            whiteSpace: 'pre-line',
                                                        }}
                                                        color={Number(card.importe) < 0 ? "red" : "black"}
                                                    >
                                                        {`\n${((Number(card.importe) / totalImporteFinalUSD) * 100).toFixed(2)}%`}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))

                                )}
                            </Grid>
                        </Box>
                    </Box>
                </Box>

                <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                    <TableContainer component={Paper} sx={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                            <TableHead>
                                <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                    <TableCell style={{ color: 'white' }}>Especie</TableCell>
                                    <TableCell style={{ color: 'white' }}>Ticker</TableCell>
                                    <TableCell style={{ color: 'white' }}>ISIN</TableCell>
                                    <TableCell style={{ color: 'white' }}>Estado</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Cantidad</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Precio</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Importe</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Costo</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Meses</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>%</TableCell>
                                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Resultado</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {homeTrade === 'ars' && (
                                    entityBalance.map((item, index) => {
                                        return setViewEntityBalance(item, index);
                                    })
                                )}
                                {homeTrade === 'usd' && (
                                    entityBalanceUSD.map((item, index) => {
                                        return setViewEntityBalanceUSD(item, index);
                                    })
                                )}
                                <TableRow sx={getRowStyle(true, 500)}>
                                    <TableCell style={{ fontWeight: 'bold' }}>Subtotal Cuenta Corriente</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    {homeTrade === 'ars' && (
                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(totalSubTotal.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotal.text}</TableCell>
                                    )}
                                    {homeTrade === 'usd' && (
                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(totalSubTotalUSD.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotalUSD.text}</TableCell>
                                    )}
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    {homeTrade === 'ars' && (
                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(totalSubTotal.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotal.text}</TableCell>
                                    )}
                                    {homeTrade === 'usd' && (
                                        <TableCell style={{ letterSpacing: "0.01rem", color: Number(totalSubTotalUSD.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotalUSD.text}</TableCell>
                                    )}
                                </TableRow>
                                {homeTrade === 'ars' && (
                                    setViewEntitHolding(entityHolding)
                                )}
                                {homeTrade === 'usd' && (
                                    setViewEntitHoldingMEP(entityHoldingUSD)
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>


            </div>
        </ThemeProvider>
    )
}

export default Position